module.exports = __webpack_public_path__ + "static/media/bauddhikgeeks-transparent.074c759b.png";